import * as React from "react";
import { Typography, Button, TextField } from "@material-ui/core";
import styled, { css } from "styled-components";
import { useTheme } from "@material-ui/styles";
import { Theme } from "../../../theme";
import * as yup from "yup";
import { Formik, FormikProps } from "formik";
import { useState, useEffect } from "react";

const StyledSection = styled.section`
  ${({ theme }: { theme: Theme }) => {
    return css`
      width: 700px;
    
      .form{
          padding-left:100px;
          padding-right:100px;
          padding-bottom:125px;
          flex-basis: 700px;
          ${theme.breakpoints.down("sm")}{
              padding-left: ${theme.spacing(2)}px
              padding-right: ${theme.spacing(2)}px
          }
      }
      .title{
          margin-top: ${theme.spacing(3)}px
      }
      .textField{
          margin-top: ${theme.spacing(1.5)}px
      }
      .signInButton{
          margin: ${theme.spacing(2, 0)}
      }
    `;
  }};
`;

interface VerifyValues {
  code: string;
}

const validationSchema = yup.object({
  code: yup
    .string()
    .min(6, "Code must be at least 6 characters long")
    .required("Code is required"),
});

export interface VerifyFormProps {
  sharedEmail: string;
  handleVerify: (code: string) => void;
  handleResend: () => void;
}

const VerifyForm: React.FC<VerifyFormProps> = props => {
  const theme: Theme = useTheme();

  //Get rid of any timer before unmount
  const [timer, setTimer] = useState<any>(undefined);
  useEffect(() => {
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, []);

  return (
    <>
      <StyledSection theme={theme}>
        <div className="form">
          <Formik
            initialValues={{ code: "" }}
            validationSchema={validationSchema}
            onSubmit={async (values, { setSubmitting }) => {
              await props.handleVerify(values.code);
              const timeout = setTimeout(() => {
                setSubmitting(false);
              }, 500);
              setTimer(timeout);
            }}
          >
            {({
              values,
              touched,
              errors,
              dirty,
              isSubmitting,
              handleChange,
              handleBlur,
              handleSubmit,
              handleReset,
              submitForm,
            }: FormikProps<VerifyValues>) => (
              <>
                <Typography className="title" variant="h2">
                  Confirm your email
                </Typography>
                <Typography color="textSecondary" gutterBottom>
                  We've sent a verification code to your email, please enter
                  below
                </Typography>
                <TextField
                  className="textField"
                  error={!!(errors.code && touched.code)}
                  fullWidth
                  helperText={errors.code && touched.code && errors.code}
                  label="Code"
                  name="code"
                  onChange={handleChange}
                  type="text"
                  value={values.code}
                  variant="outlined"
                />
                <Button
                  className="signInButton"
                  color="primary"
                  disabled={
                    isSubmitting || !dirty || Object.keys(errors).length > 0
                  }
                  onClick={submitForm}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  Verify
                </Button>
                <Typography
                  color="textSecondary"
                  variant="body1"
                  onClick={props.handleResend}
                  style={{ cursor: "pointer" }}
                >
                  Didn't recieve a code? Resend
                </Typography>
              </>
            )}
          </Formik>
        </div>
      </StyledSection>
    </>
  );
};

export default VerifyForm;
